/**
 * 路由守卫生成器
 * @param router - 路由
 * */
export default function (router) {

    /**
     * 路油导航前
     */
    router.beforeEach((to, from, next) => {
        next();
    });

    /**
     * 路由导航后
     * */
    router.afterEach((to, from) => {
    });

}